// extracted by mini-css-extract-plugin
export default {"ErrorNotificationContainer":"ErrorNotification_ErrorNotificationContainer__UkyRw"};